import type { UseActionResult, UseMutationProps } from '@ztechapps/common.hook'
import { useActionMutation } from '@ztechapps/common.hook'
import { gql } from '@apollo/client'
import { projectDocumentFragment } from './graphql'
import type { DeleteProjectTasksArgs, Project } from '@ztechapps/common.contract'

export const deleteProjectTasksQuery = gql`
  mutation deleteProjectTasks($input: DeleteProjectTasksArgs!) {
    deleteProjectTasks(input: $input) {
      ...projectDocumentFragment
    }
  }
  ${projectDocumentFragment}
`

export const useDeleteProjectTask = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Project, DeleteProjectTasksArgs> => {
  query = query ?? deleteProjectTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
